const FREE_PLAN_SKU = 'free_plan_1';
const PREMIUM_FREE_TRIAL_SKU = 'cr-anime-membership-freetrial-1';
const PREMIUM_PLUS_FREE_TRIAL_SKU =
  'cr-combo-anime-drama-manga-membership-freetrial-1';
const FAN_PACK_FREE_TRIAL_SKU = 'cr-fan-membership-freetrial-1';
const FAN_PACK_FREE_TRIAL_SKU_12 = 'cr-fan-membership-freetrial-12';
const SUPER_FAN_PACK_FREE_TRIAL_SKU = 'cr-superfan-membership-freetrial-1';

const PREMIUM_PLAN_1_MONTH_SKU = 'cr-anime-membership-1-0901';
const PREMIUM_PLAN_3_MONTHS_SKU = 'cr-anime-membership-3-0901';
const PREMIUM_PLAN_12_MONTHS_SKU = 'cr-anime-membership-12-0901';
const FAN_PACK_PLAN_1_MONTH_SKU = 'cr-fan-membership-recur-1-1802';
const FAN_PACK_PLAN_12_MONTH_SKU = 'cr-fan-membership-recur-12-2005';
const SUPER_FAN_PACK_PLAN_SKU = 'cr-superfan-membership-recur-1-1802';

const PREMIUM_FREE_TRIAL_NAME = 'Fan Membership - 2 Week Free Trial';
const FAN_PACK_FREE_TRIAL_NAME = 'Mega Fan Membership - 2 Week Free Trial';
const FAN_PACK_12_FREE_TRIAL_NAME =
  'Mega Fan Membership - 12 Months Free Trial';
const SUPER_FAN_PACK_FREE_TRIAL_NAME = 'Ultimate Fan - 2 Week Free Trial';

const PLAN_TITLES_BY_SKU = {
  [PREMIUM_PLAN_1_MONTH_SKU]: 'Fan 1 month',
  [PREMIUM_PLAN_3_MONTHS_SKU]: 'Fan 3 months',
  [PREMIUM_PLAN_12_MONTHS_SKU]: 'Fan 12 months',
  [FAN_PACK_PLAN_1_MONTH_SKU]: 'Mega Fan 1 month',
  [FAN_PACK_PLAN_12_MONTH_SKU]: 'Mega Fan 12 months',
  [SUPER_FAN_PACK_PLAN_SKU]: 'Ultimate Fan 1 month',
};

const FREE_TRIAL_PLAN_TITLE_BY_SKU = {
  [PREMIUM_FREE_TRIAL_SKU]: PREMIUM_FREE_TRIAL_NAME,
  [PREMIUM_PLUS_FREE_TRIAL_SKU]: PREMIUM_FREE_TRIAL_NAME,
  [FAN_PACK_FREE_TRIAL_SKU]: FAN_PACK_FREE_TRIAL_NAME,
  [FAN_PACK_FREE_TRIAL_SKU_12]: FAN_PACK_12_FREE_TRIAL_NAME,
  [SUPER_FAN_PACK_FREE_TRIAL_SKU]: SUPER_FAN_PACK_FREE_TRIAL_NAME,
};

const FREE_TRIAL_SKUS_ARRAY = [
  PREMIUM_FREE_TRIAL_SKU,
  PREMIUM_PLUS_FREE_TRIAL_SKU,
  FAN_PACK_FREE_TRIAL_SKU,
  FAN_PACK_FREE_TRIAL_SKU_12,
  SUPER_FAN_PACK_FREE_TRIAL_SKU,
];

const SUBSCRIPTION_SKUS_ARRAY = [
  PREMIUM_PLAN_1_MONTH_SKU,
  PREMIUM_PLAN_3_MONTHS_SKU,
  PREMIUM_PLAN_12_MONTHS_SKU,
  FAN_PACK_PLAN_1_MONTH_SKU,
  FAN_PACK_PLAN_12_MONTH_SKU,
  SUPER_FAN_PACK_PLAN_SKU,
];

const LENGTH_OF_FREE_TRIAL = '14 days';
const LENGTH_OF_MIGRATION_FREE_TRIAL = '60 days';
const LENGTH_OF_COUPON_FREE_TRIAL = 'Extended free trial';

export {
  FREE_PLAN_SKU,
  PREMIUM_FREE_TRIAL_SKU,
  PREMIUM_PLUS_FREE_TRIAL_SKU,
  FAN_PACK_FREE_TRIAL_SKU,
  FAN_PACK_FREE_TRIAL_SKU_12,
  SUPER_FAN_PACK_FREE_TRIAL_SKU,
  PLAN_TITLES_BY_SKU,
  FREE_TRIAL_SKUS_ARRAY,
  FREE_TRIAL_PLAN_TITLE_BY_SKU,
  SUBSCRIPTION_SKUS_ARRAY,
  LENGTH_OF_FREE_TRIAL,
  LENGTH_OF_COUPON_FREE_TRIAL,
  PREMIUM_PLAN_1_MONTH_SKU,
  PREMIUM_PLAN_3_MONTHS_SKU,
  PREMIUM_PLAN_12_MONTHS_SKU,
  FAN_PACK_PLAN_1_MONTH_SKU,
  FAN_PACK_PLAN_12_MONTH_SKU,
  SUPER_FAN_PACK_PLAN_SKU,
  LENGTH_OF_MIGRATION_FREE_TRIAL,
};
